import { type FC, useEffect } from "react";

import { Card, Fonts, usePrevious } from "@snapchat/snap-design-system";

import { ActionModal } from "../../camkit/common/components/ActionModal";
import { headerStyle, modalContainerStyle, modalStyle } from "../../camkit/common/styles";

import {
    HostedLensDisclaimerEnum,
    type HostedLensDisclaimerOptions,
    hostedLensDisclaimerOptions,
} from "./disclaimerOptions";

interface HostedLensDisclaimerProps {
    onCancel: () => void;
    onAction: (accepted: boolean) => Promise<void>;
    visible: boolean;
    loading: boolean;
    option: HostedLensDisclaimerOptions | null;
}

export const HostedLensDisclaimerModal: FC<HostedLensDisclaimerProps> = ({
    visible,
    loading,
    option,
    onCancel,
    onAction,
}) => {
    const prevIsLoading = usePrevious(loading);
    const selectedAction = hostedLensDisclaimerOptions[option ?? HostedLensDisclaimerEnum.GENERATE];

    useEffect(() => {
        if (prevIsLoading && !loading) {
            onCancel();
        }
    }, [loading, onCancel, prevIsLoading]);

    return (
        <ActionModal
            padBody={false}
            visible={visible}
            onCancel={onCancel}
            className={modalStyle}
            onAction={() => {
                void onAction(true);
            }}
            actionText={selectedAction.cta}
            isActionButtonPending={loading}
            isActionButtonDisabled={loading}
            isCancelButtonDisabled={loading}
            shouldAddKeyEvent={!loading}
        >
            <Card
                padBody={false}
                titleBorder={false}
                titleStyle={Fonts.Heading.H500}
                title={selectedAction.title}
                className={modalContainerStyle}
            >
                <Card.Section className={headerStyle}>{selectedAction.body}</Card.Section>
            </Card>
        </ActionModal>
    );
};
